/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import { Auth, Storage } from 'aws-amplify';
import React, { useCallback, useEffect, useState } from 'react'
import { Link, Outlet, useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import uuid from 'react-uuid';
import Header from './header';
import ErrorMessage from '../../../CommonComponent/errorMessage';
import SuccessMessage from '../../../CommonComponent/successMessage';
import config from '../../../config';
import { dataService } from '../../../services/dataService';
import { io } from 'socket.io-client';
import { useDispatch, useSelector } from 'react-redux';
import Custom404 from '../../../404';
import ToastMeassage from '../../../CommonComponent/toastMeasseage';
import { setAuctionData } from './auctionSlice';
import HeaderShimmer from './HeaderShimmer';
import LiveAuctionHeader from './LiveAuctionHeader';
import scrollToTop from '../../../CommonComponent/scrollToTop';

export default function AuctionView({unpublishModalOpen,setUnpublishModalOpen}) {
    const path = useLocation()
    const {id, uid} = useParams();
    const Navigate=useNavigate();
    const [successMessage,setSuccessMessage] = useState('')
    const [lots,setLots]=useState([])
    const [lotInfo,setLotInfo]=useState([])
    const [loading, setLoading] = useState(false)
    const [loadLots,setLoadLots]=useState(true);
    const auctionData = useSelector(state=> state.auction)
    const [searchParams, setSearchParams] = useSearchParams({ page:  1, per_page: 10 });
    const [searchParam,setSearchParam]=useSearchParams({ page:  1, per_page: 10, sort : "updated_at", order : "desc" });
    const [currentSortColumn, setCurrentSortColumn] = useState({key:null, order: 'asc'});
    const [isSearched, setIsSearched] = useState(false);
    const [uploadedFileName, setUploadedFileName] = useState('')
    const [uploadErrorMessage, setUploadErrorMessage] = useState('')
    const [showImportModal, setShowImportModal] = useState(false)
    const [isReorderLotModalOpen, setIsReorderLotModalOpen] = useState(false);
    const [importLoader, setImportLoader] = useState(false)
    const [domain,setDomain]=useState('');
    const [socketConn,setSocket]=useState(null);
    const [lotDetailsFromSocket,setLotDetailsFromSocket]=useState({});
    const [bidInformation, setBidInformation]=useState({})
    const [isSocket,setIsSocket]=useState(false);
    const dispatch = useDispatch()
    const [isAuctionInvalid , setIsAuctionInvalid] =useState(false);
    const [message,setMessage] = useState('');
    const location= useLocation();
    const [showExoprtToastMsg, setShowExportToastMsg]=useState('')
    const [joinedBidRoom, setJoinedBidRoom] = useState([]);
    const [exportBtnLoading, setExportBtnloading] =useState(false)
    const [showExportModel, setShowExportModel]=useState(false)
    

    /**
     * The function `handleView` retrieves auction data from a data service and updates the form data
     * if the retrieval is successful.
     */
    const handleView = async () => {
        setLoading(true);
        const data = await dataService.viewAuction(`?auction_id=${id}`)
        if(data.error===false){
            dispatch(setAuctionData(data.data.data))
        }else{
            setIsAuctionInvalid(true);
        }
        setLoading(false)
    }

    /**
     * The function `socketConnection` establishes a socket connection and handles various socket
     * events related to bidding and bid information.
     */
    const socketConnection=async(lots)=>{
        const idToken = await Auth.currentSession()

        if(socketConn==null){
            const socket= io(config.SOCKETURL, {
                transports: ['websocket'],
                auth: {
                    token: idToken.getIdToken().getJwtToken(),
                    type: "seller"
                },
                reconnection: true
            })

            setSocket(socket);
            setIsSocket(true);

            lots.map((item)=>{
                socket.on('authorization', (message)=>{
                    if(message.success_status==true){
                        socket.emit('joinBidRoom', item?._id, "seller");
                    }
                })
            })
            
            socket?.on('placeBid',(message)=>{
                if(message.success==true && message.newCurrentLotDetails){
                    const currentLotDetails=lotDetailsFromSocket;
                    const newLotDetails = { ...currentLotDetails, [message.newCurrentLotDetails._id]: message.newCurrentLotDetails };
                    setLotDetailsFromSocket(prevState => {
                        return { ...prevState, [message.newCurrentLotDetails._id]: message.newCurrentLotDetails };
                    });
                }
                
            })
    
            socket?.on('sellerBidInformation',(message)=>{
                setBidInformation(message)
                console.log(message,'sellerBidInformation')
            })
    
            socket?.on('joinBidRoom', (message)=>{
                setJoinedBidRoom(prev => [...prev, message._id]);
            })

        }else{
            lots.map((item)=>{
                if(!joinedBidRoom.includes(item?._id)){
                    socketConn.emit('joinBidRoom', item?._id, "seller");
                }
            })   
        }
    }


    /**
     * The function `viewDomain` makes an asynchronous call to a data service to retrieve the subdomain
     * and sets it in the state.
     */
    const viewDomain = async () => {
        const endpoint="?view=True";
        const body={}
        const response=await dataService.SubDomainSetup(endpoint,body);
        setDomain(response.data?.subdomain);
    }

    /**
    * The function `fetchHandler` fetches data from an API endpoint using the `dataService.LotList`
    * method and sets the retrieved data to the `lots` state variable.
    */
    const fetchHandler = useCallback(async (limit = 10) =>{
        let endpoint = `?auction_id=${uid}&per_page=${limit}`
        if(searchParams.get('sort')!==null){
            endpoint += `&sort_by=${String(searchParams.get('key'))}&sort_order=${String(searchParams.get('order'))}`
        }
        if(searchParams.get('search')!==null){
            endpoint += `&search_keyword=${searchParams.get('search')}`
        }
        if(searchParams.get('lotExport')!==null){
            endpoint += `&export=True`
        }
        const response = await dataService.LotList(endpoint);
        if(response.error===false){
            setLots(response.data.data);
            setLotInfo(response.data);
            setIsSearched(false)
            setExportBtnloading(false)
            setShowExportModel(false)
        }
        let params = Object.fromEntries(searchParams);
        if(response.data.csv_url){
            window.location.href= response.data.csv_url;
            delete params.lotExport
            setSearchParams({...params})
            setShowExportToastMsg('Export complete')
            setTimeout(() => {
                setShowExportToastMsg('')
            }, 4000);

        } else if(searchParams.get('lotExport')){
            delete params.lotExport;
            setSearchParams({...params});
            setUploadErrorMessage('Export Failed');
            setTimeout(() => {
                setUploadErrorMessage('')
            }, 4000);
        }
        setLoadLots(false)
    }, [location, searchParams])

    /**
     * The function `handleSearch` takes in an event, a key, and a value, and updates the search
     * parameters based on the key-value pair.
     */
    const handleSearch = (e, key, value) => {
        e.preventDefault();
        let params = Object.fromEntries(searchParams);
        params.page = 1
        if(key === 'search') {
            params[key] = encodeURIComponent(value); 
        }else {
            params[key] = value
        }
        if(params['search'] === ''){ 
            delete params.search
            setLoadLots(true);
            setIsSearched(true)        
        }
        setSearchParams({ ...params})
    }
    /**
     * The function `handleSort` is used to update the search parameters based on the sorting key and
     * order.
     */
    const handleSort = (e, key) => {
        let params = Object.fromEntries(searchParams);
        if(searchParams.get('sort') === false || searchParams.get('sort') === null) {
            params['sort'] = 'true'
            params['key'] = `${key}`
            params['order'] = `asc`
            setCurrentSortColumn({
                key: key,
                order: 'asc'
            });
        }else {
            if(searchParams.get('key').includes(key)) 
            {
                if(searchParams.get('order')==='asc') {
                    params['order'] = `dsc`
                    setCurrentSortColumn({
                        key: key,
                        order: 'dsc'
                    });
                }else{
                    params['order'] = `asc`
                    setCurrentSortColumn({
                        key: key,
                        order: 'asc'
                    });
                }
            }
            else {
                params['key'] = key
                params['order'] = `asc`
                setCurrentSortColumn({
                    key: key,
                    order: 'asc'
                });
            }
        }
        setSearchParams({ ...params})
    }


    /**
     * The function `cloneHandler` clones an auction by sending a request to the server and then
     * updates the local storage and navigates to the auctions page if the cloning is successful.
     */
    const cloneHandler = async () => {
        const body={
            "auction_id": id,
        }
        const response = await dataService.CloneAuction(body);
        if(response.error===false){
            localStorage.setItem('cloneAuction',"true");
            Navigate('/auctions')
        }
    }

    useEffect(()=>{
        if(lots.length>0 && location.pathname.includes('lots') && auctionData?.status=="Accepting bids"){
            socketConnection(lots)
        }
    },[lots, location, auctionData])
    
    const context= {
        auctionData, 
        handleView,
        lots,
        lotInfo, 
        fetchHandler, 
        handleSearch, 
        handleSort, 
        currentSortColumn, 
        searchParams,
        loading, setLoadLots,
        isSearched, 
        setSuccessMessage,
        setUploadErrorMessage,
        uploadedFileName, 
        setUploadedFileName, 
        uploadErrorMessage,
        showImportModal, 
        setShowImportModal,
        importLoader, setIsSearched,
        setImportLoader, 
        isReorderLotModalOpen,
        setIsReorderLotModalOpen, 
        lotDetailsFromSocket,setSearchParams,
        isSocket, loadLots, socketConn,
        setSearchParam,searchParam, setCurrentSortColumn,
        setExportBtnloading, exportBtnLoading,
        setShowExportModel, showExportModel,
        setShowExportToastMsg, showExoprtToastMsg
    }

    /* The `useEffect` hook is used to perform side effects in a functional component. In this case,
    the `useEffect` hook is used to fetch data and update the component's state. */
    useEffect(() => {
        scrollToTop();   
        localStorage.removeItem('lastRefresh');
        if(location.state?.message){
            setSuccessMessage(location.state?.message)
            setTimeout(() => {
                setSuccessMessage('')
            }, 4000);
            Navigate(location.pathname, { replace: true, state: null });
        }
        if(location.state?.error){
            setUploadErrorMessage(location.state?.error)
            setTimeout(()=>{
                setUploadErrorMessage("")
            }, 4000)
            Navigate(location.pathname, { replace: true, state: null });
        }
        return()=>{
            socketConn?.disconnect(true)
        }
    },[]);

    useEffect(() => {
        handleView()
        viewDomain();
    }, []);

    useEffect(()=>{
        if(Object.keys(auctionData).length>0 && auctionData?.auction_type!=="live"){
            fetchHandler();
        }
    },[auctionData, fetchHandler, searchParams])

    return (
        <>
            {!isAuctionInvalid && <div className="sm:mx-10 mx-5 sm:my-8 mt-8 mb-20">
                {successMessage!=='' && <SuccessMessage successMessage={successMessage}/>}
                {uploadErrorMessage!=='' && <ErrorMessage uploadErrorMessage={uploadErrorMessage}/>}
                {message!=="" && 
                <div className="mt-[15px] px-5 success-msg-csv py-3 bg-[#A8D9C8] border border-[#489892] rounded-[6px]">
                    <div className="flex items-center">
                        <img src="/images/verify-account.svg" alt="img" className="pr-3" />
                        <div>
                            <p className="text-[12px] leading-normal font-bold text-[#343434]" data-testid='message'>
                                {message}
                            </p>
                        </div>
                    </div>
                </div>}
                {(Object.keys(auctionData).length==0 || (auctionData?.auction_type!=="live" && loadLots)) ? <HeaderShimmer /> : (auctionData?.auction_type=="live" ? 
                    <LiveAuctionHeader auctionData={auctionData} lots={lots} cloneHandler={cloneHandler} lotInfo={lotInfo} 
                        handleView={handleView} domain={domain} bidInformation={bidInformation} showExoprtToastMsg={showExoprtToastMsg}
                        setShowExportToastMsg={setShowExportToastMsg} setUploadErrorMessage={setUploadErrorMessage}
                        unpublishModalOpen={unpublishModalOpen} setUnpublishModalOpen={setUnpublishModalOpen}
                        setMessage={setMessage} /> 
                    : 
                    <Header auctionData={auctionData} lots={lots} cloneHandler={cloneHandler} lotInfo={lotInfo} 
                        handleView={handleView} domain={domain} bidInformation={bidInformation}
                        showExoprtToastMsg={showExoprtToastMsg} setShowExportToastMsg={setShowExportToastMsg}
                        unpublishModalOpen={unpublishModalOpen} setUnpublishModalOpen={setUnpublishModalOpen}  
                        setUploadErrorMessage={ setUploadErrorMessage}
                        setMessage={setMessage}
                    />)
                }
                {/* <!-- navpills content  --> */}
                {/* <!--Tabs navigation--> */}
                <div
                    className="my-4 flex list-none flex-row flex-wrap border-b-0 pl-0"
                    id="tabs-tab3">
                    <Link to={`/auctions/${id}/${uid}/overview`} role="presentation" id="tabs-home-tab3"
                        className={`focus:border-transparen my-2 block border-x-0 border-b-2 border-t-0 
                    ml-3 sm:mr-7 mr-3 pb-1 pt-2 text-[14px] font-medium  leading-normal text-[#343434] 
                    hover:isolate focus:isolate 
                    ${path.pathname===`/auctions/${id}/${uid}/overview`?'border-[#282828]':'border-transparent'}`}>
                        Overview
                    </Link>
                    <div role="presentation" className="relative">
                        <Link to={`/auctions/${id}/${uid}/lots`}
                            className={`focus:border-transparen my-2 block border-x-0 border-b-2 border-t-0 
                        ml-3 sm:mr-7 mr-3 pb-1 pt-2 text-[14px] font-medium  leading-normal text-[#343434] 
                        hover:isolate focus:isolate 
                        ${path.pathname===`/auctions/${id}/${uid}/lots`?'border-[#282828]':'border-transparent'}`}
                            id="tabs-profile-tab3">Lots</Link>
                    </div>
                    {auctionData.auction_type!=="live" && <Link to={`/auctions/${id}/${uid}/insights`} role="presentation" id="tabs-messages-tab3"
                        className={`focus:border-transparen my-2 block border-x-0 border-b-2 border-t-0 
                    ml-3 sm:mr-7 mr-3 pb-1 pt-2 text-[14px] font-medium  leading-normal text-[#343434] 
                    hover:isolate focus:isolate 
                    ${path.pathname===`/auctions/${id}/${uid}/insights`?'border-[#282828]':'border-transparent'}`}
                    >Insights
                    </Link>}
                    {auctionData.auction_type!=="live" && <Link to={`/auctions/${id}/${uid}/bids`} role="presentation"
                        className={`focus:border-transparen my-2 block border-x-0 border-b-2 border-t-0 
                    ml-3 sm:mr-7 mr-3 pb-1 pt-2 text-[14px] font-medium  leading-normal text-[#343434] 
                    hover:isolate focus:isolate 
                    ${path.pathname===`/auctions/${id}/${uid}/bids`?'border-[#282828]':'border-transparent'}`}
                        id="bids_tab" data-testid="bids_tab">Bids
                    </Link>}
                    {auctionData.auction_type=="live" && <Link to={`/auctions/${id}/${uid}/telephone-bids`} role="presentation"
                        className={`focus:border-transparen my-2 block border-x-0 border-b-2 border-t-0 
                    ml-3 sm:mr-7 mr-3 pb-1 pt-2 text-[14px] font-medium  leading-normal text-[#343434] 
                    hover:isolate focus:isolate 
                    ${path.pathname===`/auctions/${id}/${uid}/telephone-bids`?'border-[#282828]':'border-transparent'}`}
                        id="bids_tab" data-testid="telephone-bids-tab">Telephone Bids
                    </Link>}
                    {auctionData.auction_type=="live" && <Link to={`/auctions/${id}/${uid}/absentee-bids`} role="presentation"
                        className={`focus:border-transparen my-2 block border-x-0 border-b-2 border-t-0 
                    ml-3 sm:mr-7 mr-3 pb-1 pt-2 text-[14px] font-medium  leading-normal text-[#343434] 
                    hover:isolate focus:isolate 
                    ${path.pathname===`/auctions/${id}/${uid}/absentee-bids`?'border-[#282828]':'border-transparent'}`}
                        id="bids_tab" data-testid="absentee-bids-tab">Absentee Bids
                    </Link>}
                    <Link to={`/auctions/${id}/${uid}/bidders`} role="presentation"
                        className={`focus:border-transparen my-2 block border-x-0 border-b-2 border-t-0 
                    ml-3 sm:mr-7 mr-3 pb-1 pt-2 text-[14px] font-medium  leading-normal text-[#343434] 
                    hover:isolate focus:isolate 
                    ${path.pathname===`/auctions/${id}/${uid}/bidders`?'border-[#282828]':'border-transparent'}`}
                        id="tabs-insights-tab3" data-testid="bidder-list">Bidders
                    </Link>
                    {auctionData.auction_type!=="live" && <Link to={`/auctions/${id}/${uid}/sales`} role="presentation"
                        className={`focus:border-transparen my-2 block border-x-0 border-b-2 border-t-0 
                    ml-3 sm:mr-7 mr-3 pb-1 pt-2 text-[14px] font-medium  leading-normal text-[#343434] 
                    hover:isolate focus:isolate 
                    ${path.pathname===`/auctions/${id}/${uid}/sales`?'border-[#282828]':'border-transparent'}`}
                        id="tabs-insights-tab4" data-testid="sales_list">Sales
                    </Link>}
                </div>
                {/* <!--Tabs content--> */}
                <div>
                    <Outlet context={context}/>
                
                </div>
            
            </div>}
            {isAuctionInvalid && <Custom404 />}
        </>
    )
}
